import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PocketbaseService } from '../../services/pocketbase.service';

@Component({
  selector: 'app-profile-overview',
  imports: [RouterLink],
  templateUrl: './profile-overview.component.html',
  styleUrl: './profile-overview.component.scss'
})
export class ProfileOverviewComponent {

  constructor(
    private readonly pocketbaseService: PocketbaseService
  ) { }


  public logout(): void {
    this.pocketbaseService.logout();
  }



}
